export const globalConfig = defineStore('global', {
  state: () => ({
    config: {},
    whoami: {},
    packs: [],
    faqs: [],
    location: {},
  }),
  actions: {
    setWhoami(whoami) {
      this.whoami = whoami;
    },
    setGlobalConfig(config) {
      this.config = config;
    },
    setPacks(packs) {
      this.packs = packs;
    },
    setFaqs(faqs) {
      this.faqs = faqs;
    },
    setLocation(location) {
      this.location = location;
    },
    setLatLng({ lat, lng }) {
      this.location.loc = [lat, lng].join(',');
    },
    setLocationError(error) {
      this.location.error = error;
    },
    clearLocationError() {
      this.location.error = null;
    }
  },
  getters: {
    ownerId: (state) => state?.whoami?.ownerId,
    role: (state) => state?.whoami?.role,
    ownerPlan: (state) => state?.config?.owner_plan,
    logo: (state) => state?.config?.site?.assets?.find((a) => a.type === 'LOGO'),
    siteName: (state) => state?.config?.site?.name,
    hasPacks: (state) => state?.packs?.length > 0
  },
  persist: {
    pick: ['faqs'],
    storage: piniaPluginPersistedstate.localStorage()
  }
});
